module.exports = __webpack_public_path__ + "static/media/asset.f1adde98.svg";